<template>
<v-app>

    <v-main>
        
    </v-main>
</v-app>

</template>

<script setup>



</script>